import { route } from '@community_dev/requests'
import { Api } from '@community_dev/types'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'

export type ActivityCategory = CamelCasedPropertiesDeep<Api.ActivityLog.Category>
export type ActivityClient = CamelCasedPropertiesDeep<Api.ActivityLog.Client>
export type ActivityActor = CamelCasedPropertiesDeep<Api.ActivityLog.Actor>
export type ActivityRow = CamelCasedPropertiesDeep<Api.ActivityLog.Row>
export type Page<T> = CamelCasedPropertiesDeep<Api.ActivityLog.Page<T>>

export type ActivitiesParams = Api.ActivityLog.ActivitiesParams
export type CatalogParams = Api.ActivityLog.CatalogParams

function compactQuery(params: Record<string, unknown>): Record<string, string | number> {
  const out: Record<string, string | number> = {}
  for (const [k, v] of Object.entries(params)) {
    if (v == null || v === '' || v === false) continue
    if (Array.isArray(v)) {
      if (v.length === 0) continue
      out[k] = v.join(',')
    } else {
      out[k] = v as string | number
    }
  }
  return out
}

export function getActivities(params: ActivitiesParams = {}): Promise<Page<ActivityRow>> {
  return request(route(ENDPOINTS.ACTIVITY_LOG.ACTIVITIES, {}, compactQuery(params)))
}

export function getActivity(id: string): Promise<ActivityRow> {
  return request(route(ENDPOINTS.ACTIVITY_LOG.ACTIVITY, { id }))
}

export function getCategories(): Promise<ActivityCategory[]> {
  return request(ENDPOINTS.ACTIVITY_LOG.CATEGORIES)
}

export function getClients(params: CatalogParams = {}): Promise<Page<ActivityClient>> {
  return request(route(ENDPOINTS.ACTIVITY_LOG.CLIENTS, {}, compactQuery(params)))
}

export function getActors(params: CatalogParams = {}): Promise<Page<ActivityActor>> {
  return request(route(ENDPOINTS.ACTIVITY_LOG.ACTORS, {}, compactQuery(params)))
}
